import ScrollToTopPage from "Components/ScrollToTopPage/ScrollToTopPage";
import Footer from "../../Components/Footer/Footer";
import NavbarMenu from "../../Components/NavbarMenu/NavbarMenu";

import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <div className="max-w-[1600px] mx-auto overflow-hidden">
      <NavbarMenu />
      <Outlet />
      <ScrollToTopPage />
      <Footer />
      </div>
    </>
  );
};

export default Layout;
